export const inventoryTranslations = {
  ar: {
    title: 'المخزون',
    search: 'بحث...',
    filter: 'تصفية',
    refresh: 'تحديث',
    lowStock: 'كميات منخفضة',
    item: 'البند',
    store: 'المستودع',
    quantity: 'الكمية',
    minQty: 'الحد الأدنى',
    maxQty: 'الحد الأقصى',
    cost: 'التكلفة',
    price: 'السعر',
    category: 'التصنيف',
    barcode: 'الباركود',
    transfer: 'تحويل',
    transferInventory: 'تحويل مخزون',
    fromStore: 'من مستودع',
    toStore: 'إلى مستودع',
    selectItem: 'اختر البند',
    selectStore: 'اختر المستودع',
    quantityLabel: 'الكمية',
    notes: 'ملاحظات',
    save: 'حفظ',
    cancel: 'إلغاء',
    noInventory: 'لا توجد بيانات مخزون',
    loading: 'جاري تحميل المخزون...',
    error: 'فشل تحميل المخزون',
    transferSuccess: 'تم تحويل المخزون بنجاح',
    transferError: 'فشل تحويل المخزون',
    summary: 'ملخص',
    movements: 'الحركات',
    showZeroQuantity: 'إظهار الكميات الصفرية',
    date: 'التاريخ',
    recordedQuantity: 'الكمية المسجلة',
    actualQuantity: 'الكمية الفعلية',
    difference: 'الفرق',
    totalCost: 'التكلفة الإجمالية',
    export: 'تصدير',
    newAdjustment: 'تسوية جديدة',
    clearFilters: 'مسح الفلاتر',
    branch: 'الفرع',
    fromDate: 'من تاريخ',
    toDate: 'إلى تاريخ',
    total: 'الإجمالي',
    results: 'نتائج',
    totalIncrease: 'إجمالي الزيادة',
    totalDecrease: 'إجمالي النقص',
    noData: 'لا توجد بيانات',
    adjustmentType: 'نوع التسوية',
    unit: 'الوحدة',
    unitCost: 'تكلفة الوحدة',
    description: 'الوصف',
    increase: 'زيادة',
    decrease: 'نقص',
    journalEntry: 'قيد محاسبي',
    actions: 'الإجراءات',
    viewJournalEntry: 'عرض القيد المحاسبي',
    noJournalEntry: 'لا يوجد قيد محاسبي',
    print: 'طباعة',
    showing: 'عرض',
    of: 'من',
    page: 'صفحة',
  },
  en: {
    title: 'Inventory',
    search: 'Search...',
    filter: 'Filter',
    refresh: 'Refresh',
    lowStock: 'Low Stock',
    item: 'Item',
    store: 'Store',
    quantity: 'Quantity',
    minQty: 'Min Qty',
    maxQty: 'Max Qty',
    cost: 'Cost',
    price: 'Price',
    category: 'Category',
    barcode: 'Barcode',
    transfer: 'Transfer',
    transferInventory: 'Transfer Inventory',
    fromStore: 'From Store',
    toStore: 'To Store',
    selectItem: 'Select Item',
    selectStore: 'Select Store',
    quantityLabel: 'Quantity',
    notes: 'Notes',
    save: 'Save',
    cancel: 'Cancel',
    noInventory: 'No inventory data',
    loading: 'Loading inventory...',
    error: 'Failed to load inventory',
    transferSuccess: 'Inventory transferred successfully',
    transferError: 'Failed to transfer inventory',
    summary: 'Summary',
    movements: 'Movements',
    showZeroQuantity: 'Show Zero Quantity',
    date: 'Date',
    recordedQuantity: 'Recorded Quantity',
    actualQuantity: 'Actual Quantity',
    difference: 'Difference',
    totalCost: 'Total Cost',
    export: 'Export',
    newAdjustment: 'New Adjustment',
    clearFilters: 'Clear Filters',
    branch: 'Branch',
    fromDate: 'From Date',
    toDate: 'To Date',
    total: 'Total',
    results: 'results',
    totalIncrease: 'Total Increase',
    totalDecrease: 'Total Decrease',
    noData: 'No Data',
    adjustmentType: 'Adjustment Type',
    unit: 'Unit',
    unitCost: 'Unit Cost',
    description: 'Description',
    increase: 'Increase',
    decrease: 'Decrease',
    journalEntry: 'Journal Entry',
    actions: 'Actions',
    viewJournalEntry: 'View Journal Entry',
    noJournalEntry: 'No Journal Entry',
    print: 'Print',
    showing: 'Showing',
    of: 'of',
    page: 'Page',
  },
  fr: {
    title: 'Inventaire',
    search: 'Rechercher...',
    filter: 'Filtrer',
    refresh: 'Actualiser',
    lowStock: 'Stock faible',
    item: 'Article',
    store: 'Magasin',
    quantity: 'Quantité',
    minQty: 'Qté min',
    maxQty: 'Qté max',
    cost: 'Coût',
    price: 'Prix',
    category: 'Catégorie',
    barcode: 'Code-barres',
    transfer: 'Transfert',
    transferInventory: 'Transfert d\'inventaire',
    fromStore: 'Du magasin',
    toStore: 'Au magasin',
    selectItem: 'Sélectionner l\'article',
    selectStore: 'Sélectionner le magasin',
    quantityLabel: 'Quantité',
    notes: 'Notes',
    save: 'Enregistrer',
    cancel: 'Annuler',
    noInventory: 'Aucune donnée d\'inventaire',
    loading: 'Chargement de l\'inventaire...',
    error: 'Échec du chargement de l\'inventaire',
    transferSuccess: 'Inventaire transféré avec succès',
    transferError: 'Échec du transfert de l\'inventaire',
    summary: 'Résumé',
    movements: 'Mouvements',
    showZeroQuantity: 'Afficher les quantités zéro',
    date: 'Date',
    recordedQuantity: 'Quantité enregistrée',
    actualQuantity: 'Quantité réelle',
    difference: 'Différence',
    totalCost: 'Coût total',
    export: 'Exporter',
    newAdjustment: 'Nouveau ajustement',
    clearFilters: 'Effacer les filtres',
    branch: 'Succursale',
    fromDate: 'De la date',
    toDate: 'À la date',
    total: 'Total',
    results: 'résultats',
    totalIncrease: 'Augmentation totale',
    totalDecrease: 'Diminution totale',
    noData: 'Aucune donnée',
    adjustmentType: 'Type d\'ajustement',
    unit: 'Unité',
    unitCost: 'Coût unitaire',
    description: 'Description',
    increase: 'Augmentation',
    decrease: 'Diminution',
    journalEntry: 'Écriture comptable',
    actions: 'Actions',
    viewJournalEntry: 'Voir l\'écriture comptable',
    noJournalEntry: 'Aucune écriture comptable',
    print: 'Imprimer',
    showing: 'Affichage',
    of: 'de',
    page: 'Page',
  },
}


